import { render, staticRenderFns } from "./ultra-main.vue?vue&type=template&id=0802b16a&scoped=true"
import script from "./ultra-main.vue?vue&type=script&lang=js"
export * from "./ultra-main.vue?vue&type=script&lang=js"
import style0 from "./ultra-main.vue?vue&type=style&index=0&id=0802b16a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0802b16a",
  null
  
)

export default component.exports